export default __webpack_public_path__ + "media/images/79-8674f68f30179db8b985e5b2793178f3.jpg";